import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 767px) {
    padding: 1.5rem 1rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const HeaderCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
`;

export const Subtitle = styled.p`
  margin: 0;
  color: var(--text-muted);
  font-size: 0.9375rem;
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const BackLink = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: var(--text-primary);
  }
`;

export const Meta = styled.span`
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted);
`;

export const Muted = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
`;

export const Select = styled.select`
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-surface);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.875rem;
`;

export const Notice = styled.div<{ $tone?: 'info' | 'warning' | 'error' }>`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  border: 1px solid var(--border);
  background: var(--bg-elevated);
  color: ${(p) =>
    p.$tone === 'error'
      ? 'var(--error)'
      : p.$tone === 'warning'
        ? 'var(--warning)'
        : 'var(--text-secondary)'};
`;

export const CostTierText = styled.span`
  display: inline-flex;
  flex-direction: column;
  font-size: 0.8125rem;
  color: var(--text-primary);

  span {
    font-size: 0.6875rem;
    letter-spacing: 0.1em;
    color: var(--accent);
  }
`;
